<template>
    <div id="AssetFeatureCategoryList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                <div class="page-title"> Asset Feature Category List</div>
                    <router-link v-if="canAdd == true" class="btn btn-primary pull-right" v-bind:to="{name: 'AssetFeatureCategoryCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-feature-catlist">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'filterable: true'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'filterable: true'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listAssetFeatureCategoryTable"
                                    mode="remote"
                                    title="AssetFeatureCategory"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: asset_feature_category_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Feature Category" v-if="canUpdate" class="fp-edit" v-bind:to="{name: 'AssetFeatureCategoryEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="asset_feature_category_value == true" id="deleteAssetFeatureCategoryBtn" v-on:click.prevent="assetFeatureCategoryDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "AssetFeatureCategoryList",
        metaInfo() {
            return {title: "Asset Feature Category List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                 {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created By',
                    field: 'created_by',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Created By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_feature_category_value: false,
            loading:false,
            canAdd:false,
            canUpdate:false
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_feature_category') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset_feature_category') {
                            self.asset_feature_category_value = true;
                        }
                        if (permissions[i].name == 'add_asset_feature_category') {
                            self.canAdd = true;
                            self.canUpdate = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetFeatureCategoryTable.unselectAllInternal();
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('created_at');
                    field:('created_by')
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.created_at || filters.created_by) {
                    this.loadList();
                }
            },*/

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/assetfeaturecategory/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'feature-cate-list')
                    }
                });
            },

            assetFeatureCategoryDelete() {
                var data = this.$refs['listAssetFeatureCategoryTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listAssetFeatureCategoryTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Asset Feature Category? ')) {
                    self.loading = true;
                    $("#deleteAssetFeatureCategoryBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/assetfeaturecategory/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteAssetFeatureCategoryBtn").val("Delete");
                            }, 10000);
                            if (data.code == 200) {
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'feature-cate-delete')
                        }
                    });
                }
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/AssetFeatureCategoryList.vue